// extracted by mini-css-extract-plugin
export var filterIncDec = "_dv-0";
export var leftBorder = "_dv-1";
export var rightBorder = "_dv-2";
export var stringInput = "_dv-3";